const $ = require("jquery");
import Chart from 'chart.js/auto';

(function () {
    var duration = 1000;
    var $charts = $("canvas[data-chart]");

    var $numbers = $('[data-number]');
    $numbers.each(function (x, number) {
        var $number = $(number);

        $(window).scroll(function () {
            var inView = $number.hasClass('showing')
            if (chartInView($number)) {
                if (inView) { return; }
                $number.addClass('showing')
                animateNumber($number);
            }
            else {
                $number.removeClass('showing')
            }
        });
    });  

    $charts.each(function (x, chart) {
        var $chart = $(chart)
        drawDoughnutChart(chart);

        if (chartInView($chart)) {
            $chart.addClass('showing')
            changeChartValue(chart, $chart.data('chartPercentage'));
        }

        $(window).scroll(function () {
            var inView = $chart.hasClass('showing')

            if (chartInView($chart)) {
                if (inView) { return; }
                $chart.addClass('showing')
                changeChartValue(chart, $chart.data('chartPercentage'));
            } else {
                $chart.removeClass('showing')
                changeChartValue(chart, 0);
            }
        });
    });

    function animateNumber($element) {
        var end = $element.data('number');
        var start = Math.max(end - 100, 0);
        var percentage = $element.data('percentage')

        if (start === end) return;
        var range = end - start;
        var current = start;
        var increment = end > start ? 1 : -1;
        var stepTime = Math.abs(Math.floor(duration / range));

        var timer = setInterval(function () {
            current += increment;
            if (percentage)
                $element.html(current + '%');
            else
                $element.html(numberTousandsSeparator(current));

            if (current == end) {
                clearInterval(timer);
            }
        }, stepTime);
    }

    function chartInView($element) {
        var docViewTop = $(window).scrollTop();
        var docViewBottom = docViewTop + $(window).height();

        var elemTop = $element.offset().top;
        var elemBottom = elemTop + $element.height();

        return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
    }

    function drawDoughnutChart(chart) {
        var graph = Chart.getChart(chart)

        if (graph)
            graph.destroy();      

        var data = {
            datasets: [{
                data: [100, 0],
                borderWidth: 0,
                backgroundColor: ['#D7F5F3', '#4FAFA8']
            }],
        };

        var options = {
            cutoutPercentage: 40,
            aspectRatio: 1,
            animation: {
                duration: 0,
            },
            legend: {
                display: false
            },
            plugins: {
                tooltip: {
                    enabled: false // <-- this option disables tooltips
                }
            }
        }

        new Chart(chart.getContext('2d'), {
            type: 'doughnut',
            data: data,
            options: options
        });
    }

    function changeChartValue(chart, precentage) {
        var graph = Chart.getChart(chart)
        var values = [(100 - precentage), precentage]

        graph.data.datasets.forEach(dataset => {
            dataset.data = values
        });

        graph.options.animation.duration = duration;

        graph.update();
    }

    function numberTousandsSeparator(x, separator) {
        separator = separator || " "
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    }
})();